module.exports = __webpack_public_path__ + "img/bg_b.5f3966c9.png";